
Greenmile.Actions = Greenmile.Actions || {};
Greenmile.Actions.EMAIL = {
  template: () => (
    {
      tag: 'div',
      items: [
        {
          items: [
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: 'event.email.to',
                      attributes: {
                        class: 'i18nResource',
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'emailToCurrentCustomer',
                  },
                },
                {
                  items: [
                    {
                      tag: 'label',
                      items: [
                        {
                          tag: 'input',
                          attributes: {
                            type: 'radio',
                            id: 'emailToCurrentCustomer',
                            name: 'radio_email',
                            checked: 'checked',
                            class: 'modelAttribute',
                          },
                        },
                      ],
                    },
                  ],
                  attributes: {
                    class: 'control-label radioEmail',
                  },
                },
              ],
              attributes: {
                class: 'control-radio email-action-radio',
              },
            },
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: 'event.sms.managers',
                      attributes: {
                        class: 'i18nResource',
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'emailToManagers',
                  },
                },
                {
                  items: [
                    {
                      tag: 'label',
                      items: [
                        {
                          tag: 'input',
                          attributes: {
                            type: 'radio',
                            id: 'emailToManagers',
                            name: 'radio_email',
                            class: 'modelAttribute',
                          },
                        },
                      ],
                    },
                  ],
                  attributes: {
                    class: 'control-label radioEmail',
                  },
                },
              ],
              attributes: {
                class: 'control-radio email-action-radio',
              },
            },
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: 'event.sms.customer',
                      attributes: {
                        class: 'i18nResource',
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'emailToAllCustomers',
                  },
                },
                {
                  items: [
                    {
                      tag: 'label',
                      items: [
                        {
                          tag: 'input',
                          attributes: {
                            type: 'radio',
                            id: 'emailToAllCustomers',
                            name: 'radio_email',
                            class: 'modelAttribute',
                          },
                        },
                      ],
                    },
                  ],
                  attributes: {
                    class: 'control-label radioEmail',
                  },
                },
              ],
              attributes: {
                class: 'control-radio email-action-radio',
              },
            },
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: 'event.email.eventLocation',
                      attributes: {
                        class: 'i18nResource',
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'emailToEventLocation',
                  },
                },
                {
                  items: [
                    {
                      tag: 'label',
                      items: [
                        {
                          tag: 'input',
                          attributes: {
                            type: 'radio',
                            id: 'emailToEventLocation',
                            name: 'radio_email',
                            class: 'modelAttribute',
                          },
                        },
                      ],
                    },
                  ],
                  attributes: {
                    class: 'control-label radioEmail',
                  },
                },
              ],
              attributes: {
                class: 'control-radio email-action-radio',
              },
            },
            {
              items: [
                {
                  tag: 'label',
                  items: [
                    {
                      tag: 'span',
                      html: 'event.email.driver',
                      attributes: {
                        class: 'i18nResource',
                      },
                    },
                  ],
                  attributes: {
                    class: 'control-label',
                    for: 'emailToDrivers',
                  },
                },
                {
                  items: [
                    {
                      tag: 'label',
                      items: [
                        {
                          tag: 'input',
                          attributes: {
                            type: 'radio',
                            id: 'emailToDrivers',
                            name: 'radio_email',
                            class: 'modelAttribute',
                          },
                        },
                      ],
                    },
                  ],
                  attributes: {
                    class: 'control-label radioEmail',
                  },
                },
              ],
              attributes: {
                class: 'control-radio email-action-radio',
              },
            },
          ],
          attributes: {
            class: 'group-radio',
          },
        },
        {
          items: [
            {
              tag: 'label',
              items: [
                {
                  tag: 'span',
                  html: 'event.email.to',
                  attributes: {
                    class: 'i18nResource',
                  },
                },
              ],
              attributes: {
                class: 'control-label',
                for: 'action_email_to',
              },
            },
            {
              items: [
                {
                  tag: 'input',
                  attributes: {
                    type: 'text',
                    maxlength: '120',
                    name: 'action_email_to',
                    id: 'action_email_to',
                    class: 'modelAttribute textField mandatory',
                    autocomplete: 'off',
                  },
                },
              ],
              attributes: {
                class: 'controls',
              },
            },
          ],
          attributes: {
            class: 'hideShowActionEmailTo',
          },
        },
        {
          attributes: {
            class: 'accounttype-container hideField',
          },
        },
        {
          tag: 'label',
          items: [
            {
              tag: 'span',
              html: 'event.email.from',
              attributes: {
                class: 'i18nResource',
              },
            },
          ],
          attributes: {
            class: 'control-label',
            for: 'action_email_from',
          },
        },
        {
          items: [
            {
              tag: 'input',
              attributes: {
                type: 'text',
                maxlength: '120',
                name: 'action_email_from',
                id: 'action_email_from',
                class: 'modelAttribute textField mandatory',
                autocomplete: 'off',
              },
            },
          ],
          attributes: {
            class: 'controls',
          },
        },
        {
          tag: 'label',
          items: [
            {
              tag: 'span',
              html: 'event.email.subject',
              attributes: {
                class: 'i18nResource',
              },
            },
          ],
          attributes: {
            class: 'control-label',
            for: 'action_email_subject',
          },
        },
        {
          items: [
            {
              tag: 'input',
              attributes: {
                type: 'text',
                maxlength: '80',
                name: 'action_email_subject',
                id: 'action_email_subject',
                class: 'modelAttribute textField mandatory',
                autocomplete: 'off',
              },
            },
          ],
          attributes: {
            class: 'controls',
          },
        },
        {
          tag: 'label',
          items: [
            {
              tag: 'span',
              html: 'event.email.body',
              attributes: {
                class: 'i18nResource',
              },
            },
          ],
          attributes: {
            class: 'control-label',
            for: 'action_email_body',
          },
        },
        {
          items: [
            {
              attributes: {
                id: 'action_email_body',
              },
            },
          ],
          attributes: {
            class: 'controls email',
          },
        },
      ],
    }),
  hideOrShowAttributes: (selectedRadioId) => {
    const divInputTo = document.querySelector('.hideShowActionEmailTo');
    const inputTo = document.querySelector('#action_email_to');
    const getAccountTypeContainer = () => (document.querySelector('.accounttype-container'));
    const hideToField = () => {
      inputTo.value = '';
      divInputTo.classList.add('hideField');
      inputTo.className = 'modelAttribute textField';
    };
    const hideAccountType = () => {
      getAccountTypeContainer().classList.add('hideField');
      App.Forms.EventLookupAccountTypeEmail.lookupElement.clear();
    };
    const showToField = () => {
      divInputTo.classList.remove('hideField');
      inputTo.className = 'modelAttribute textField mandatory';
    };

    const showAccountType = () => {
      getAccountTypeContainer().classList.remove('hideField');
    };

    switch (selectedRadioId) {
      case 'emailToCurrentCustomer':
        showToField();
        hideAccountType();
        break;
      case 'emailToAllCustomers':
        showAccountType();
        hideToField();
        break;
      case 'emailToEventLocation':
      case 'emailToDrivers':
      case 'emailToManagers':
        hideAccountType();
        hideToField();
        break;
      default:
        return false;
    }
  },

  addListener: () => {
    const receivedEmail = document.getElementsByName('radio_email');
    const fromField = document.getElementById('action_email_from');
    fromField.value = Monet.I18n.getResourcesByKey('event.action.email.from');
    if (receivedEmail) {
      receivedEmail.forEach((email) => {
        email.addEventListener('click', (e) => {
          Greenmile.Actions.EMAIL.hideOrShowAttributes(e.target.id);
        });
      });
    }
  },
  addAccountTypeLookupList: () => {
    const lookupAccountType = new Monet.UI.Fields.Render({
      name: 'accountTypes',
      label: Monet.I18n.getResourcesByKey('location.accountType'),
      mandatory: false,
      type: 'POWER_LOOKUP_LIST_FILTER',
      lookupEntity: 'AccountType',
      lookupEntityColumn: 'description',
    }, 'EventEmailAction').render();

    const container = document.querySelector('#Event .accounttype-container');
    container.appendChild(lookupAccountType.rootEl);
    lookupAccountType.postRender();
    App.Forms.EventLookupAccountTypeEmail = { lookupElement: lookupAccountType };
  },
  initializeRichTextComponent: (editorSelector) => {
    const toolbarOptions = [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }]
    ];
    const quill = new Quill(editorSelector, {
      modules: {
        toolbar: toolbarOptions
      },
      theme: 'snow'
    });
    return quill;
  },

  prepareAutoComplete: (selector) => {
    const REGEX = /(@(?:(?:\w|\d|\.)+)(?!\w|\d|\.))[^@]/;
    $(`${selector} .ql-editor`).on("keypress", () => {
      $(`${selector} .ql-editor`).on('keydown', (event) => {
        if (event.keyCode === $.ui.keyCode.TAB && $(this).data('autocomplete').menu.active) {
          event.preventDefault();
        }
      }).autocomplete({
        minLength: 0,
        source: (request, response) => {
          const richEditor = App.Forms.Event.Actions.Email.richEditor;
          const text = richEditor.container.firstElementChild.innerHTML;
          const terms = text.match(REGEX);
          if (terms) {
            const term = terms[1];
            response($.ui.autocomplete.filter(
              Greenmile.Event.AutoComplete.autoCompleteTags,
              Greenmile.Event.AutoComplete.extractLast(
                term.replace('@', ''))
              )
            );
          } else {
            response();
          }
        },
        focus: () => (false),
        select: (event, ui) => {
          const richEditor = App.Forms.Event.Actions.Email.richEditor;
          const matched = richEditor.getText().match(REGEX);
          if (matched) {
            const pattern = matched[1];
            richEditor.deleteText(matched.index, pattern.length);
            richEditor.insertText(matched.index, ui.item.value);
          }
          return false;
        }
      });
    });
  },

  prepareBodyComponent: () => {

    const CONTAINER_SELECTOR = '.email .ql-toolbar.ql-snow';
    const quill = Greenmile.Actions.EMAIL.initializeRichTextComponent('#action_email_body');
    const container = document.querySelector(CONTAINER_SELECTOR);
    const selectFieldList = new Greenmile.Event.SelectFieldList(CONTAINER_SELECTOR);
    selectFieldList.setAvailableTags(Greenmile.Event.AutoComplete.loadEmailAvailableTags());

    App.Forms.Event.Actions = App.Forms.Event.Actions || {};
    App.Forms.Event.Actions.Email = App.Forms.Event.Actions.Email || {};
    App.Forms.Event.Actions.Email.richEditor = quill;

    selectFieldList.addClickEventListener((field) => {
      if (field) {
        quill.insertText(quill.getText().length - 1, ` ${field.value}`, '', true);
      }
    });
    selectFieldList.render();

    container.appendChild(selectFieldList.elFieldList);
    Greenmile.Actions.EMAIL.prepareAutoComplete('#action_email_body');
    Greenmile.Actions.EMAIL.addAccountTypeLookupList();
  },

  assignParameter: (jsonParam) => {
    const param = (jsonParam) ? JSON.parse(jsonParam) : {};
    document.querySelector('input[name="radio_email"]#emailToCurrentCustomer').checked = !!param.toCurrentCustomer;
    document.querySelector('input[name="radio_email"]#emailToAllCustomers').checked = !!param.toAllCustomers;
    document.querySelector('input[name="radio_email"]#emailToManagers').checked = !!param.toManagers;
    document.querySelector('input[name="radio_email"]#emailToEventLocation').checked = !!param.emailToEventLocation;
    document.querySelector('input[name="radio_email"]#emailToDrivers').checked = !!param.toDrivers;

    document.querySelector('#action_email_to').value = param.to || '';
    document.querySelector('#action_email_from').value = param.from || '';
    document.querySelector('#action_email_subject').value = param.subject;
    document.querySelector('#action_email_body').value = param.body;

    const richEditor = App.Forms.Event.Actions.Email.richEditor;

    richEditor.container.firstElementChild.innerHTML = decodeURI(param.body);

    if (param.accountTypesIds) {
      App.Forms.EventLookupAccountTypeEmail.lookupElement.setValue(param.accountTypesIds);
    }

    if (param.toCurrentCustomer && !param.toCurrentCustomer) {
      const divInputTo = document.querySelector('.hideShowActionEmailTo');
      divInputTo.classList.add('hideField');
      divInputTo.children[1].children[0].className = 'modelAttribute textField';
    }

    Greenmile.Actions.EMAIL.hideOrShowAttributes((() => {
      let type = '';
      if (!!param.toManagers) {
        type = 'emailToManagers';
      } else if (!!param.emailToEventLocation) {
        type = 'emailToEventLocation';
      } else if (!!param.toDrivers) {
        type = 'emailToDrivers';
      } else if (!!param.toAllCustomers) {
        type = 'emailToAllCustomers';
      } else {
        type = 'emailToCurrentCustomer';
      }
      return type;
    })());
  },

  retrieveParameter: () => {
    let emailTo = document.querySelector('#action_email_to') || '';
    if (emailTo) {
      emailTo = emailTo.value || '';
    }
    const toAllCustomersIsChecked = document.querySelector('input[name="radio_email"]#emailToAllCustomers').checked;
    const accountTypesIds = App.Forms.EventLookupAccountTypeEmail.lookupElement.getValue();
    const emailBody = encodeURI(App.Forms.Event.Actions.Email.richEditor.container.firstElementChild.innerHTML);

    const result = JSON.stringify({
      toAllCustomers: toAllCustomersIsChecked,
      toManagers: document.querySelector('input[name="radio_email"]#emailToManagers').checked,
      toCurrentCustomer: document.querySelector('input[name="radio_email"]#emailToCurrentCustomer').checked,
      emailToEventLocation: document.querySelector('input[name="radio_email"]#emailToEventLocation').checked,
      toDrivers: document.querySelector('input[name="radio_email"]#emailToDrivers').checked,
      to: emailTo,
      from: $('#action_email_from').val(),
      subject: $('#action_email_subject').val(),
      body: emailBody,
      accountTypesIds: (toAllCustomersIsChecked ? accountTypesIds.map(item => (item.id)) : [])
    });

    return result.replace(/\\"/g, '"');
  }
};
